
import { Component,Prop,  Vue} from "vue-property-decorator";

@Component
export default class ButtonVue extends Vue {

  @Prop() callback!: Function;
  @Prop() type!: string;
  @Prop() title!: string;
  @Prop() text!: string;
  @Prop() red!: number|undefined;
  @Prop() pressed!: boolean|undefined;
  @Prop() inactive!: boolean|undefined;

}
